import VirtualizedTable from './VirtualizedTable.component';

export default VirtualizedTable;
